import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function OAuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    // Tokens come in URL fragment (from OAuth or SSO callback)
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const accessToken = params.get('access_token');
    const refreshToken = params.get('refresh_token');

    // Check for errors in query string (SSO/OAuth errors)
    const queryParams = new URLSearchParams(window.location.search);
    const error = queryParams.get('error');

    if (error) {
      // Redirect to login with error message
      sessionStorage.setItem('authError', error);
      window.location.href = '/';
      return;
    }

    if (accessToken && refreshToken) {
      // Parse the JWT to extract user info for AuthProvider state
      let user = { id: '', email: '', displayName: '', tenantId: '', role: '', isTenantAdmin: false, mfaEnabled: false };
      try {
        const base64 = accessToken.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const payload = JSON.parse(atob(base64));
        user = {
          id: payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'] || '',
          email: payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'] || '',
          displayName: payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'] || '',
          tenantId: payload['tid'] || '',
          role: payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || '',
          isTenantAdmin: payload['is_tenant_admin'] === 'true',
          mfaEnabled: false,
        };
      } catch {
        // If JWT parsing fails, store tokens anyway — AuthProvider will fetch /auth/me
      }

      // Store in the format AuthProvider expects
      sessionStorage.setItem('auth', JSON.stringify({
        accessToken,
        refreshToken,
        user,
        isAuthenticated: true,
      }));

      // Also store in legacy format for backward compatibility
      sessionStorage.setItem('accessToken', accessToken);
      sessionStorage.setItem('refreshToken', refreshToken);

      window.location.href = '/'; // Full reload to pick up new auth state
    } else {
      navigate('/');
    }
  }, [navigate]);

  return null;
}
